export const actions = {
    SET_LOCALE: 'SET_LOCALE',
    SET_REG_TYPE: 'SET_REG_TYPE',
    GET_TRANSLATIONS: 'GET_TRANSLATIONS',
    GET_TRANSLATIONS_SUCCESS: 'GET_TRANSLATIONS_SUCCESS',
    GET_TRANSLATIONS_FAILURE: 'GET_TRANSLATIONS_FAILURE',
    SET_STEP: 'SET_STEP',
    SET_STEP_PAYLOAD: 'SET_STEP_PAYLOAD',
    GET_NEXT_STEP: 'GET_NEXT_STEP',
    GET_NEXT_STEP_SUCCESS: 'GET_NEXT_STEP_SUCCESS',
    GET_NEXT_STEP_FAILURE: 'GET_NEXT_STEP_FAILURE',
    UPLOAD_FILE: 'UPLOAD_FILE',
    UPLOAD_FILE_SUCCESS: 'UPLOAD_FILE_SUCCESS',
    UPLOAD_FILE_FAILURE: 'UPLOAD_FILE_FAILURE',
    CHECK_AGENT_ID: 'CHECK_AGENT_ID',
    CHECK_AGENT_ID_SUCCESS: 'CHECK_AGENT_ID_SUCCESS',
    CHECK_AGENT_ID_FAILURE: 'CHECK_AGENT_ID_FAILURE',
    SHOW_GLOBAL_ERROR_MESSAGE: 'SHOW_GLOBAL_ERROR_MESSAGE',
    HIDE_GLOBAL_ERROR_MESSAGE: 'HIDE_GLOBAL_ERROR_MESSAGE',
    SET_USER_NAME: 'SET_USER_NAME',
    PREVIOUSLY_COMPLETED_STEP_SIGN_TRUE: 'PREVIOUSLY_COMPLETED_STEP_SIGN_TRUE',
    PREVIOUSLY_COMPLETED_STEP_SIGN_FALSE: 'PREVIOUSLY_COMPLETED_STEP_SIGN_FALSE',
    GET_SPECIFIC_STEP: 'GET_SPECIFIC_STEP',
    GET_SPECIFIC_STEP_SUCCESS: 'GET_SPECIFIC_STEP_SUCCESS',
    GET_SPECIFIC_STEP_FAILURE: 'GET_SPECIFIC_STEP_FAILURE',
    SET_SPECIFIC_STEP: 'SET_SPECIFIC_STEP',
    CHECK_ID_NUMBER: 'CHECK_ID_NUMBER',
    CHECK_ID_NUMBER_SUCCESS: 'CHECK_ID_NUMBER_SUCCESS',
    CHECK_ID_NUMBER_FAILURE: 'CHECK_ID_NUMBER_FAILURE',
    UPLOAD_ID_FILE: 'UPLOAD_ID_FILE',
    UPLOAD_ID_FILE_SUCCESS: 'UPLOAD_ID_FILE_SUCCESS',
    UPLOAD_ID_FILE_FAILURE: 'UPLOAD_ID_FILE_FAILURE',
};
